import { tns } from "tiny-slider";
import "tiny-slider/dist/tiny-slider.css";

export function initProfessionalsCarousel() {
  const sliders = document.querySelectorAll(".js-professionals-carousel");

  if (!sliders.length) return;

  sliders.forEach((slider) => {
    const wrapper = slider.closest(".js-professionals-carousel-wrapper");
    const prevButton = wrapper?.querySelector(".js-professionals-prev");
    const nextButton = wrapper?.querySelector(".js-professionals-next");
    const toggleBtn = wrapper?.querySelector(".js-toggle-cards");

    const isDesktop = () => window.matchMedia("(min-width: 768px)").matches;

    const hideNavButtons = () => {
      if (prevButton) prevButton.style.display = "none";
      if (nextButton) nextButton.style.display = "none";
    };

    const instance = tns({
      container: slider,
      gutter: 16,
      slideBy: 1,
      speed: 600,
      mouseDrag: true,
      swipeAngle: 45,
      controls: false,
      nav: false,
      autoplay: false,
      autoplayButtonOutput: false,
      loop: false,
      responsive: {
        0: {
          disable: true,
        },
        768: {
          disable: false,
          fixedWidth: 390,
          gutter: 24,
        },
      },
    });

    if (toggleBtn) {
      const textMore = toggleBtn.querySelector(".js-text-more");
      const textLess = toggleBtn.querySelector(".js-text-less");

      toggleBtn.addEventListener("click", () => {
        const isExpanded = toggleBtn.classList.contains("is-expanded");
        const hiddenCards = Array.from(slider.querySelectorAll(".js-card-item")).slice(3);

        if (isExpanded) {
          hiddenCards.forEach((card) => card.classList.add("hidden"));
          toggleBtn.classList.remove("is-expanded");
          if (textMore) textMore.classList.remove("hidden");
          if (textLess) textLess.classList.add("hidden");
        } else {
          hiddenCards.forEach((card) => card.classList.remove("hidden"));
          toggleBtn.classList.add("is-expanded");
          if (textMore) textMore.classList.add("hidden");
          if (textLess) textLess.classList.remove("hidden");
        }
      });
    }

    function updateButtons() {
      if (!instance.isOn || !isDesktop()) {
        hideNavButtons();
        return;
      }

      const info = instance.getInfo();
      const index = info.index;
      const slideCount = info.slideCount;
      const items = info.items;

      if (prevButton) {
        prevButton.style.display = index === 0 ? "none" : "flex";
      }

      if (nextButton) {
        nextButton.style.display = index + items >= slideCount ? "none" : "flex";
      }
    }

    updateButtons();

    instance.events.on("indexChanged", updateButtons);

    instance.events.on("newBreakpointEnd", () => {
      updateButtons();
    });

    window.addEventListener("resize", updateButtons);

    if (prevButton) {
      prevButton.addEventListener("click", () => {
        if (instance.isOn && isDesktop()) instance.goTo("prev");
      });
    }

    if (nextButton) {
      nextButton.addEventListener("click", () => {
        if (instance.isOn && isDesktop()) instance.goTo("next");
      });
    }
  });
}